const DCV_DISABLED_TYPES = ['t3.micro', 't3.small'];
export default DCV_DISABLED_TYPES;
